import styled from "styled-components";

export const Card = styled.div`
	display: flex;
	flex-direction: column;
	font-size: 12px;
	margin: 0 auto;
	background-color: #f4f6fa;
	padding: 0.5rem;
`;
